export default "<h3>Please select a Recipe!</h3>\n"